import React from 'react'

export const EmailIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#FF798D" fill-opacity="0.24" />
      <path
        d="M16.167 4.91699H7.83366C5.33366 4.91699 3.66699 6.16699 3.66699 9.08366V14.917C3.66699 17.8337 5.33366 19.0837 7.83366 19.0837H16.167C18.667 19.0837 20.3337 17.8337 20.3337 14.917V9.08366C20.3337 6.16699 18.667 4.91699 16.167 4.91699ZM16.5587 9.99199L13.9503 12.0753C13.4003 12.517 12.7003 12.7337 12.0003 12.7337C11.3003 12.7337 10.592 12.517 10.0503 12.0753L7.44199 9.99199C7.17533 9.77533 7.13366 9.37533 7.34199 9.10866C7.55866 8.84199 7.95033 8.79199 8.21699 9.00866L10.8253 11.092C11.4587 11.6003 12.5337 11.6003 13.167 11.092L15.7753 9.00866C16.042 8.79199 16.442 8.83366 16.6503 9.10866C16.867 9.37533 16.8253 9.77533 16.5587 9.99199Z"
        fill="#DE2F4C"
      />
    </svg>
  )
}
